import { styled } from '@linaria/react';

export const PremiumContainer = styled.div`
	display: flex;
	max-width: 500px;
	flex-flow: column nowrap;
	gap: var(--gap-m);
`;

export const PremiumList = styled.ul`
	display: flex;
	flex-flow: column nowrap;
	gap: var(--gap-xs);
`;

export const PremiumListItem = styled.li`
	position: relative;
	font-size: var(--font-size-l);
`;
